import React from 'react';

import { Box, COLORS, Text } from '@clutter/clean';

export const ExpandableItem = ({ children }: { children: React.ReactNode }) => (
  <Text.Callout color={COLORS.storm}>
    <Box.Flex justifyContent="space-between">{children}</Box.Flex>
  </Text.Callout>
);
